import React from 'react';
import { injectIntl } from 'react-intl';

import ReactEcharts from 'components/HTMLElements/ReactECharts';
import ChartConfig from 'constants/ChartConfig';

const Chart = ( { data = {}, intl, chatActive, phoneActive, kpi, days } ) => {
  const area = {};
  const series = [
    intl.formatMessage( { id: "db_status" } ),
    intl.formatMessage( { id: "email_status" } ),
    intl.formatMessage( { id: "facebook_status" } ),
    intl.formatMessage( { id: "incms_status" } ),
    intl.formatMessage( { id: "twitter_status" } ),
    //intl.formatMessage( { id: "whatsapp_status" } ),
  ];
  //if( phoneActive ) series.push( intl.formatMessage( { id: "sms_status" } ) )

  let dataDb = [];
  let dataEmail = [];
  let dataFacebook = [];
  let dataIncms = [];
  let dataTwitter = [];
  let dataSms = [];
  
  if (kpi === 'incidents' ) {
    dataDb = data['db_status'] ? data['db_status'][kpi] : 0,
    dataEmail = data['email_status'] ? data['email_status'][kpi] : 0,
    dataFacebook = data['facebook_status'] ? data['facebook_status'][kpi] : 0,
    dataIncms = data['incms_status'] ? data['incms_status'][kpi] : 0,
    dataTwitter = data['twitter_status'] ? data['twitter_status'][kpi] : 0
    //dataSms = data['sms_status'] ? data['sms_status'][kpi] : 0 
  } else {
    dataDb = data['db_status'] ? Math.round( ( ( ( data['db_status'][kpi] / Number(days ) ) + Number.EPSILON) * 100))  / 100  : 0,
    dataEmail = data['email_status'] ? Math.round(( ( ( data['email_status'][kpi] / Number(days ) ) + Number.EPSILON) * 100) ) / 100  : 0,
    dataFacebook = data['facebook_status'] ? Math.round(( ( ( data['facebook_status'][kpi] / Number(days ) ) + Number.EPSILON) * 100) ) / 100 : 0,
    dataIncms = data['incms_status'] ? Math.round(( ( ( data['incms_status'][kpi] / Number(days ) ) + Number.EPSILON) * 100) ) / 100  : 0,
    dataTwitter = data['twitter_status'] ? Math.round(( ( ( data['twitter_status'][kpi] / Number(days ) ) + Number.EPSILON) * 100) ) / 100 : 0
    //dataSms = data['sms_status'] ? data['sms_status'][kpi] / days : 0 
  }
  

  const seriesYResolved = [
    dataDb,
    dataEmail,
    dataFacebook,
    dataIncms,
    dataTwitter,
   // data['whatsapp_status'] ? data['whatsapp_status']['incidents'] : 0,
  ]
  //if( phoneActive ) seriesYResolved.push( dataSms )


  area.options = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: [ kpi === 'incidents' ? intl.formatMessage( { id: "fail" } ) : intl.formatMessage( { id: "uptimeAvg" } )],
      textStyle: {
        color: ChartConfig.color.text
      }
    },
    toolbox: {
      show: false
    },
    calculable: true,
    xAxis: [
      {
        type: 'category',
        data: series,
        axisLabel: {
          textStyle: {
            color: ChartConfig.color.text
          }
        },
        splitLine: {
          lineStyle: {
            color: ChartConfig.color.splitLine
          }
        }
      }
    ],
    yAxis: [
      {
        axisLabel: {
          textStyle: {
            color: ChartConfig.color.text
          }
        },
        splitLine: {
          lineStyle: {
            color: ChartConfig.color.splitLine
          }
        },
        splitArea: {
          show: true,
          areaStyle: {
            color: ChartConfig.color.splitArea
          }
        }
      }
    ],
    series: [
      {
        name: kpi === 'incidents' ? intl.formatMessage( { id: "fails" } ) : intl.formatMessage( { id: "uptimeAvg" } ),
        type: 'bar',
        data: seriesYResolved,
        itemStyle: {
          normal: {
            color:  kpi === 'incidents' ? ChartConfig.color.danger : ChartConfig.color.info 
          }
        },
        lineStyle: {
          normal: {
            color: ChartConfig.color.info
          }
        },
        areaStyle: {
          normal: {
            color: ChartConfig.color.info
          }
        },
        symbol: 'diamond'
      },

    ]
  };
  return (
    <ReactEcharts style={{ height: '350px' }} option={area.options} showLoading={false}/> );
};

module.exports = injectIntl( Chart );



// WEBPACK FOOTER //
// ./routes/app/components/Dashboard/KPIsChartUptime.js